import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import React, { createContext, useMemo, useState } from 'react';

export const ColorModeContext = createContext({ toggle: () => { } });

export default function AppTheme({ children }) {
    const [mode, setMode] = useState('light');
    const colorMode = { toggle: () => setMode(p => (p === 'light' ? 'dark' : 'light')) };

    const theme = useMemo(() => createTheme({
        palette: { mode, primary: { main: '#1976d2' } },
        shape: { borderRadius: 10 },
    }), [mode]);

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <CssBaseline />
                {children}
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
}